/**
 * Scroll observer - https://css-tricks.com/using-intersectionobserver-to-check-if-page-scrolled-past-certain-point/
 */


/**
 * Timeline
 */
 var component_scroll_observer_timeline = function() {

  const elements = document.querySelectorAll('.timeline-block__item');

  elements.forEach(element => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {

        if (entry.isIntersecting) {

          entry.target.classList.add('item-visible');

          // Element is intersecting with the viewport
          //console.log('Element is visible');
          // Perform your desired actions here
        } else {
          // Element is not intersecting with the viewport
          //console.log('Element is not visible');
          // Perform your desired actions here
        }
      });
    });

    observer.observe(element);
  });


  // make the call chainable
  return this;

};
